import React from 'react'
import {
    List,
    Datagrid,
    TextField,
    DateField,
    ReferenceField,
} from 'react-admin'

const TranscriptRequestList = (props) => (
    <>
        <p>Click on any field header to sort by that field</p>
        <List {...props} sort={{ field: 'createdAt', order: 'DESC' }}>
            <Datagrid rowClick="edit">
                <TextField source="mediaId" label="Recording ID" />
                <ReferenceField
                    label="Recording"
                    source="mediaId"
                    reference="recordings"
                >
                    <TextField source="title" />
                </ReferenceField>
                <TextField label="ASR ID" source="asrId" />
                <StatusField source="status" label="Status" />
                <DateField source="createdAt" label="Date" />
                <MediaLinkField />
            </Datagrid>
        </List>
    </>
)

const MediaLinkField = ({ record = {} }) => {
    return (
        <a
            href={`/recording/${record.mediaId}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            View on Magor
        </a>
    )
}

export default TranscriptRequestList

const StatusField = ({ record = {}, source = 'status' }) => {
    const status = ((record && record[source]) || '').toLowerCase()

    let bg = '#6b7280' 
    if (status === 'success') bg = '#16a34a' // green
    else if (status === 'pending' || status === 'queue' || status === 'progress') bg = '#f59e0b' // amber
    else if (status === 'error' || status === 'failure') bg = '#dc2626' // red

    const style = {
        backgroundColor: bg,
        color: '#fff',
        padding: '4px 8px',
        borderRadius: 12,
        display: 'inline-block',
        minWidth: 72,
        textAlign: 'center',
        fontSize: 12,
        textTransform: 'capitalize',
    }

    const label = record.status || ''

    return <span style={style}>{label}</span>
}